<template>
  <b-row>
    <b-col :cols='12'>
      <b-row>
          <b-col v-if='this.editingVisit < 1' :cols='12' class="scroll" style="overflow-x:auto">
            <b-row>
              <b-col :cols='12'>
                <h3>Resultados</h3>
              </b-col>
            </b-row>
              <!-- <b-table empty-text="No hay ningún registro que mostrar" :show-empty='true' :items='tableItems' :fields='tableFields'>
                  <template slot='manager' slot-scope='row'>
                      <span>{{ row.item.nombre_visitador }} ({{ row.item.codigo_visitador }})</span>
                  </template>
                  <template slot='id_entidad_dict.nombre_entidad' slot-scope='row'>
                      <span>{{ row.item.id_entidad_dict.nombre_entidad + ' (CIF: ' + row.item.id_entidad_dict.cif + ') - (SAP:' + row.item.id_entidad_dict.codigo_entidad + ')' }}</span>
                  </template>
                  <template slot='fecha_hora_proxima_visita' slot-scope='row'>
                      <span>{{ row.item.fecha_hora_proxima_visita|formatDate('DD/MM/YYYY HH:mm') }} </span>
                  </template>
                  <template slot='fecha_hora_visita' slot-scope='row'>
                      <span>{{ row.item.fecha_hora_visita|formatDate('DD/MM/YYYY HH:mm') }} </span>
                  </template>
                  <template slot='acciones' slot-scope='row'>
                      <div style="min-width:120px;">
                          <b-btn @click='editRow(row.item.id_visita_entidad , $event)' size='sm' variant='default'><i class='p-0 fa fa-pencil'></i> Editar</b-btn> <b-btn @click='removeRow(row.item.id_visita_entidad , $event)' size='sm' variant='danger'><i class='p-0 fa fa-trash'></i></b-btn>
                      </div>
                  </template>
              </b-table> -->
              <div style="max-height: 50rem;">
                <table class='table custom'>
                  <thead id="head">
                    <tr>
                      <th style="min-width:75px">Acciones</th>
                      <th style="min-width:500px">Entidad</th>
                      <th style="min-width:200px">Fecha planificada</th>
                      <th style="min-width:200px">Fecha realizada</th>
                      <th style="min-width:250px">Gestor</th>
                      <th style="min-width:100px">Estado</th>
                      <th style="min-width:200px">Tipo actividad</th>
                      <th style="min-width:100px">Resultado</th>
                      <th style="min-width:250px">Observaciones</th>
                    </tr>
                  </thead>
                  <tbody id="body">
                    <tr v-for="item in tableItems" v-bind:key="item.id">
                      <td style="min-width:75px">
                        <b-dropdown variant="link" no-caret>
                          <template slot="button-content">
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                          </template>
                          <b-dropdown-item-button @click='editRow(item.id_visita_entidad)'>Editar</b-dropdown-item-button>
                          <b-dropdown-item-button @click="removeRow(item.id_visita_entidad)">Eliminar</b-dropdown-item-button>
                        </b-dropdown>
                      </td>
                      <td style="min-width:500px">{{ item.id_entidad_dict.nombre_entidad + ' (CIF: ' + item.id_entidad_dict.cif + ') - (SAP:' + item.id_entidad_dict.codigo_entidad + ')' }}</td>
                      <td style="min-width:200px">{{ item.fecha_hora_proxima_visita|formatDate('DD/MM/YYYY HH:mm') }}</td>
                      <td style="min-width:200px">{{ item.fecha_hora_visita|formatDate('DD/MM/YYYY HH:mm') }}</td>
                      <td style="min-width:250px">{{ item.nombre_visitador }} ({{ item.codigo_visitador }})</td>
                      <td style="min-width:100px">{{item.status_visita}}</td>
                      <td style="min-width:200px">{{item.tipo_actividad}}</td>
                      <td style="min-width:100px">{{item.resultado}}</td>
                      <td style="min-width:250px">{{item.observaciones}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </b-col>
          <b-col v-else>
              <b-row>
                <b-col :cols='12'>
                  <h3>Resultados > Editando visita</h3>
                </b-col>
              </b-row>
              <b-row>
                <b-col :cols='12'>
                  <ManageVisitsEntitiesResultsEdit :id-visita='this.editingVisit'></ManageVisitsEntitiesResultsEdit>
                </b-col>
              </b-row>
          </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style scoped>
.fixed_header tbody{
  display:block;
  overflow:auto;
  height:500px;
  width:100%;
}
.fixed_header thead tr{
  display:block;
}
.table {
  display: block;
}
.table tr td {
    padding: 0rem 0rem;
}
table tbody, table thead{
  display: block;
  overflow-y: auto;
}
table tbody {
   max-height: 30rem;
}
</style>

<script>

import ManageVisitsEntitiesResultsEdit from './ManageVisitsEntitiesResultsEdit';
import moment from 'moment';

export default {
  name: 'ManageVisitsEntitiesResults',
  props: ['data'],
  components: { ManageVisitsEntitiesResultsEdit },
  data () {
    return {
      editingVisit: 0,
      tableItems: [],
      tableFields: [
        {key: 'id_entidad_dict.nombre_entidad', label: 'Entidad'},
        {key: 'fecha_hora_proxima_visita', label: 'Fecha planificada'},
        {key: 'fecha_hora_visita', label: 'Fecha realizada'},

        {key: 'manager', label: 'Gestor'},

        {key: 'status_visita', label: 'Status'},
        {key: 'tipo_actividad_visita_entidad', label: 'Tipo actividad'},
        {key: 'id_resultado_visita_dict.resultado', label: 'Resultado'},
        {key: 'observaciones', label: 'Observaciones'},
        {key: 'acciones'}
      ]
    };
  },
  computed: {
  },
  created: function () {
    this.editingVisit = 0;
    this.processData();
  },
  mounted: function () {
    this.editingVisit = 0;

    window.$('#head, #body').on('scroll', function () {
      window.$('#head, #body').scrollLeft(window.$(this).scrollLeft());
    });
  },
  watch: {
    data () {
      this.processData();
    }
  },
  filters: {
    formatDate: function (value, fmt) {
      // console.log(value, fmt)
      let format = fmt || 'YYYY-MM-DD';

      if (value !== null) {
        return moment(value).format(format);
      }
      return value;
    }
  },
  methods: {

    goBackResults () {
      this.$parent.showManageVisitsEntitiesResultsPopup = false;
    },

    // goBackDetails () {
    //   this.editingVisit = 0
    // },

    editRow (id) {
      this.editingVisit = id;
    },

    removeRow (id) {
      let th = this;
      if (confirm('¿Seguro que quieres eliminar esta visita?')) {
        this.$http.delete('visitas_entidades/' + id + '/').then(response => {
          th.$emit('delete');
        });
      }
    },

    processData () {
      this.tableItems = this.data;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/CommercialManagement/ManageVisitsEntitiesResults.vue